export default "__VITE_ASSET__DmotXpoU__"